import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Link } from 'react-router-dom';
import Spinner from "../common/Spinner";
import { activateAcount } from "../../redux/actions/authActions"

function ActivateAccountPage({
    auth,
    history,
    activateAcount,
    ...props
}) {

    const [errors, setErrors] = useState({});
    const [processing, setProcessing] = useState(true);
    const [activationComplete, setActivationComplete] = useState(false);

    useEffect(() => {
        if (auth.isAuthenticated) {
            history.push("/");
        }
        document.title = "Activate Account | JustGoRide";
        //pull code from querystring
        var urlParams = new URLSearchParams(window.location.search);
        var activationCode = urlParams.get('ref');

        setProcessing(true);
        activateAcount(activationCode).then((result) => {
            setProcessing(false);
            setActivationComplete(true);
        })
        .catch(error => {
            setProcessing(false);
            setErrors({ onProcessingActivation: error.message });
        });



    }, []);

 
    return (
        <div className="container">
            {processing ?
                <Spinner />
                :
                (activationComplete ?
                <div className="py-5">
                    <h2 className="text-center">Your account is active</h2>
                    <p className="text-center">
                        Thank you for activating your account.
                    </p>
                    <p className="text-center">
                        Click <Link to={"/login"}>here</Link> to login.
                    </p>
                </div>
                :
                <div className="py-5">
                    <h2 className="text-center">Your request for activation is invalid</h2>
                    <p className="text-center">
                        If you followed a link from inside an activation email, 
                        please email admin@justgoride.co.uk stating your username 
                        and we'll check that your account was created correctly.
                    </p>
                </div>)
            }
        </div>
    );

}

ActivateAccountPage.propTypes =
    {
        auth: PropTypes.object.isRequired, 
        activateAcount: PropTypes.func.isRequired
    }


function mapStateToProps(state) {
    return {
        auth: state.auth
    };
}

const mapDispatchToProps = {
    activateAcount
}

export default connect(mapStateToProps, mapDispatchToProps)(ActivateAccountPage); 


// WEBPACK FOOTER //
// ./src/components/user/ActivateAccountPage.js